'use strict';

var dateFns = require('date-fns');
var parseMillisecondsToTimeDuration = require('./parseMillisecondsToTimeDuration.cjs');

function dateIntervalToTimeDuration({ start, end }, options) {
  return parseMillisecondsToTimeDuration(
    dateFns.differenceInMilliseconds(end, start),
    options
  );
}

exports.dateIntervalToTimeDuration = dateIntervalToTimeDuration;
//# sourceMappingURL=dateIntervalToTimeDuration.cjs.map
